
export default {
  methods: {
    config (key) {
      return this.$store.state.settings.values[key]
    },
  },
}
